var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingname(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 16.25V3.5C13.25 3.086 12.914 2.75 12.5 2.75H6.5C6.086 2.75 5.75 3.086 5.75 3.5V16.25",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 7.25H2.75C2.336 7.25 2 7.586 2 8V16.25",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.25V8C17 7.586 16.664 7.25 16.25 7.25H13.25",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 13.25H11.375",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 13.25V16.25",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 16.25V13.25",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.375H11",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.625H11",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.125H11",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10.625H5.75",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 13.25H5.75",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10.625H14.75",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13.25H14.75",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 16.25H1.25",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingname);
export default __webpack_public_path__ + "static/media/buildingname.2f82fad560f0f54c9adaf199715f6ff6.svg";
export { ForwardRef as ReactComponent };